import { isAddress } from 'ethers/lib/utils';
import { IUniswapV3DataProvider__factory } from './typechain/IUniswapV3DataProvider__factory';
export class UniswapV3DataProvider {
    // private readonly chainId: number;
    /**
     * Constructor
     * @param context The ui pool data provider context
     */
    constructor(context) {
        if (!isAddress(context.uniswapV3DataProviderAddress)) {
            throw new Error('contract address is not valid');
        }
        this._contract = IUniswapV3DataProvider__factory.connect(context.uniswapV3DataProviderAddress, context.provider);
        // this.chainId = context.chainId;
    }
    async getPositionsData({ tokenIds, }) {
        return this._contract.getPositionsData(tokenIds);
    }
}
//# sourceMappingURL=index.js.map